import { GENERIC_AUTHENTICATION_WARNING } from './authenticationMessages';
import appConfig from 'src/config/app.json';

export type AuthenticationLayout = 'legacy' | 'new';

interface AuthenticationAppConfig {
  authentication?: {
    loginLayout?: AuthenticationLayout;
  };
}

export interface AuthenticationCopy {
  emailLabel: string;
  emailPlaceholder: string;
  forgotPasswordInvalidEmailWarning: string;
  forgotPasswordInvalidVerificationWarning: string;
  forgotPasswordTitle: string;
  forgotPasswordUnexpectedErrorMessages: string[];
  invalidLoginWarning: string;
  setPasswordTitle: string;
  signInTitle?: string;
}

const LEGACY_AUTHENTICATION_COPY: AuthenticationCopy = {
  emailLabel: 'EMAIL',
  emailPlaceholder: 'Email',
  forgotPasswordInvalidEmailWarning: 'Invalid email.',
  forgotPasswordInvalidVerificationWarning: 'Invalid verification code provided, please try again.',
  forgotPasswordTitle: 'FORGOT PASSWORD?',
  forgotPasswordUnexpectedErrorMessages: [
    'Something unexpected happened.',
    'Please try again or contact support@alucio.io',
  ],
  invalidLoginWarning: 'Invalid email / password error',
  setPasswordTitle: 'SET PASSWORD',
};

const NEW_AUTHENTICATION_COPY: AuthenticationCopy = {
  emailLabel: 'Email',
  emailPlaceholder: 'you@company.com',
  forgotPasswordInvalidEmailWarning: GENERIC_AUTHENTICATION_WARNING,
  forgotPasswordInvalidVerificationWarning: GENERIC_AUTHENTICATION_WARNING,
  forgotPasswordTitle: 'Forgot password?',
  forgotPasswordUnexpectedErrorMessages: [GENERIC_AUTHENTICATION_WARNING],
  invalidLoginWarning: GENERIC_AUTHENTICATION_WARNING,
  setPasswordTitle: 'Set password',
  signInTitle: 'Welcome!',
};

export const getAuthenticationLayout = (
  search?: string,
  configuredLayout: AuthenticationLayout | undefined =
  (appConfig as AuthenticationAppConfig).authentication?.loginLayout,
): AuthenticationLayout => {
  const requestedLayout = new URLSearchParams(search).get('login');

  if (requestedLayout === 'legacy' || requestedLayout === 'new') {
    return requestedLayout;
  }

  return configuredLayout === 'legacy' ? 'legacy' : 'new';
};

export const getAuthenticationCopy = (search?: string): AuthenticationCopy =>
  getAuthenticationLayout(search) === 'legacy'
    ? LEGACY_AUTHENTICATION_COPY
    : NEW_AUTHENTICATION_COPY;

export const getAuthenticationEmailPlaceholder = (search?: string): string =>
  getAuthenticationCopy(search).emailPlaceholder;

export const shouldReserveForgotPasswordErrorSpace = (
  search: string | undefined,
  hasError: boolean,
): boolean => hasError || getAuthenticationLayout(search) === 'legacy';

export const getForgotPasswordMessageAlignment = (
  search?: string,
): 'center' | 'start' => getAuthenticationLayout(search) === 'legacy' ? 'center' : 'start';
